import React, { Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

import { publicRoutesName } from "./PublicRouterName";
import { privateRoutesName } from "./PrivateRoutesName";
const Routes = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Switch>
        {publicRoutesName.map((item, index) => {
          return (
            <Route
              exact={item.exact}
              path={item.path}
              key={index}
              component={item.component}
            ></Route>
          );
        })}

        {privateRoutesName.map((item, index) => {
          return (
            <PrivateRoute
              exact={item.exact}
              path={item.path}
              key={index}
              component={item.component}
            ></PrivateRoute>
          );
        })}
      </Switch>
    </Suspense>
  );
};

export default Routes;
